// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__-hash--base64-5-","Label":"BuildControl__Label__-hash--base64-5-","Less":"BuildControl__Less__-hash--base64-5-","More":"BuildControl__More__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 96
// module chunks = 0